import React, { useEffect, useMemo, useState } from "react";
import caretup from "../assets/images/caret-up.png";
import caretdown from "../assets/images/caret-down.png";
import { Dropdown } from 'primereact/dropdown';
import { ProductService } from '../service/ProductService';
import 'primeicons/primeicons.css';
import * as echarts from "echarts";
import ReactEcharts from "echarts-for-react";
import TopNav from "../components/common/topnav.component";
import ProgressBar from "@ramonak/react-progress-bar";
import students from "../assets/images/student_image.png";
import Studentgrp from "../assets/images/student_image_1.png";
import school from "../assets/images/interschool_image.png";
import RightArrow from "../assets/images/right-arrow.png";
import Edvisiondarklogo from '../assets/images/edvision-logo-dark.svg';
import { useDispatch, useSelector } from "react-redux";
import {
    fetchEnrollment, fetchSpecial_Group, fetchEthnicity_Mix, fetchSPED_Enrollment, fetchNet_Movement, fetchGraduation_To_KG_Enrollment_Ratio,
    fetchInter_School_Conversion, fetchSchools_Biggest_Gainers, fetchSchools_Biggest_Losers, fetchTime_Analysis, fetchEnrollment_Time_Analysis,
    fetchEnrollment_Summary_By_Dimensions,
    fetchSchool_Going_Population,
    fetchKG_Grade12_Ratio
} from '../redux/slices/enrollment';
import HorizontalStackBars from "../components/common/horizontalstackbars";
import LoaderContainer from "../components/LoaderContainer/LoaderContainer";
import AppliedFilters from "../components/filterComponent/AppliedFilters";
import { convertIntoCommaSeperated } from "../utils";
import { RadioButton } from "primereact/radiobutton";
import { Tooltip } from "primereact/tooltip";
import InfoWithOverlay from "../components/chartwrapper/InfoOverlay";

export default function StrengthWeakness(props) {

    const options = [
        { name: 'School Type', value: 'school_level' },
        { name: 'Grade Level', value: 'student_grade' },
        { name: 'Ethnicity', value: 'student_ethnicity' },
        { name: 'Gender', value: 'student_gender' },
        { name: 'Students with Disabilities', value: 'STUDENT_SPECIAL_ABILITY' },
        { name: 'EL', value: 'student_ell' },
        { name: 'Free and Reduced Lunch', value: 'STUDENT_ECONOMICALLY_DISADVANTAGED' },
        // { name: 'Hispanic', value: 'STUDENT_HISPANIC' },
        // { name: 'Language Classification', value: 'student_language_classification' }
    ];
    const [enrollment, setEnrollment] = useState("student_gender");
    sessionStorage.setItem("enrollmentdimension", enrollment);
    const dispatch = useDispatch();
    const Enrollmentdata = useSelector(state => state.enrollment.Enrollment);
    const Enrollmentloading = useSelector(state => state.enrollment.Enrollmentloading);
    const School_Going_Populationdata = useSelector(state => state.enrollment.School_Going_Population);
    const School_Going_Populationloading = useSelector(state => state.enrollment.School_Going_Populationloading);
    const Special_Groupdata = useSelector(state => state.enrollment.Special_Group);
    const Ethnicity_Mixdata = useSelector(state => state.enrollment.Ethnicity_Mix);
    const Ethnicity_Mixloading = useSelector(state => state.enrollment.Ethnicity_Mixloading);
    const SPED_Enrollmentdata = useSelector(state => state.enrollment.SPED_Enrollment);
    const SPED_Enrollmentloading = useSelector(state => state.enrollment.SPED_Enrollmentloading);
    const Net_Movementdata = useSelector(state => state.enrollment.Net_Movement);
    const Graduation_To_KG_Enrollment_Ratiodata = useSelector(state => state.enrollment.Graduation_To_KG_Enrollment_Ratio);
    const Inter_School_Conversiondata = useSelector(state => state.enrollment.Inter_School_Conversion);
    const Schools_Biggest_Gainersdata = useSelector(state => state.enrollment.Schools_Biggest_Gainers);
    const Schools_Biggest_Gainersloading = useSelector(state => state.enrollment.Schools_Biggest_Gainersloading);
    const Schools_Biggest_Losersdata = useSelector(state => state.enrollment.Schools_Biggest_Losers);
    const Schools_Biggest_Losersdataloading = useSelector(state => state.enrollment.Schools_Biggest_Losersdataloading);
    const Time_Analysisdata = useSelector(state => state.enrollment.Time_Analysis);
    const Enrollment_Time_Analysisdata = useSelector(state => state.enrollment.Enrollment_Time_Analysis);
    const Enrollment_Summary_By_Dimensionsdata = useSelector(state => state.enrollment.Enrollment_Summary_By_Dimensions);
    const KG_Grade12_Ratiodata = useSelector(state => state.enrollment.KG_Grade12_Ratio);

    const Special_Grouploadingdata = useSelector(state => state.enrollment.Special_Grouploading);
    const Net_Movementloadingdata = useSelector(state => state.enrollment.Net_Movementloading);
    const Graduation_To_KG_Enrollment_Ratioloadingdata = useSelector(state => state.enrollment.Graduation_To_KG_Enrollment_Ratioloading);
    const Inter_School_Conversionloadingdata = useSelector(state => state.enrollment.Inter_School_Conversionloading);
    const Time_Analysisloadingdata = useSelector(state => state.enrollment.Time_Analysisloading);
    const Enrollment_Summary_By_Dimensionsloadingdata = useSelector(state => state.enrollment.Enrollment_Summary_By_Dimensionsloading);
    const Schools_Biggest_Losersloadingdata = useSelector(state => state.enrollment.Schools_Biggest_Losersloading);
    const KG_Grade12_Ratioloadingdata = useSelector(state => state.enrollment.KG_Grade12_Ratioloading);

    /* Net Movement Order */
    const Net_MovementOrdered = ["Newly Enrolled Students", "Loss Count", "Total Net Movement of Students"];
    const Net_MovementOrderedData = [...Net_Movementdata]?.sort((a, b) => Net_MovementOrdered?.indexOf(a.METRIC_NAME) - Net_MovementOrdered?.indexOf(b.METRIC_NAME));
    /*  */

    const [screenWidth, setScreenWidth] = useState(0);
    useEffect(() => {
    const handleResize = () => {
        if (typeof window !== 'undefined') {
        const screenWidth = window.innerWidth;
        setScreenWidth(screenWidth);
        }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
        window.removeEventListener('resize', handleResize);
    };
    }, []);

    const SortData = (data, KEY) => {
        const sorteddata = [...data]?.sort((a, b) => {
            return b[KEY] - a[KEY]
        })
        return sorteddata
    }

    const customOrder = ["Below 5 Years", "5-9 Years", "9-14 Years", "15-19 Years"];

    const SortEthnicityData = (data) => {
        return [...data].sort((a, b) => {
            return customOrder.indexOf(a.STUDENT_ETHNICITY) - customOrder.indexOf(b.STUDENT_ETHNICITY);
        });
    };

    const sortedSpecial_Groupdata = SortData(Special_Groupdata, "VALUE")
    const sortedEthnicity_Mixdata = SortEthnicityData(Ethnicity_Mixdata)
    const [selectedOption, setSelectedOption] = useState('Enrollment');

    useEffect(() => {
        dispatch(fetchEnrollment({
            "elasticQueryName": "Enrollment",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
            //   "userEmail": 'Test.PBI@redingtongroup.com'
        }));
        dispatch(fetchSchool_Going_Population({
            "elasticQueryName": "School_Going_Population",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
            //   "userEmail": 'Test.PBI@redingtongroup.com'
        }));
        dispatch(fetchSpecial_Group({
            "elasticQueryName": "Special_Group",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchEthnicity_Mix({
            "elasticQueryName": "Ethnicity_Mix",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchSPED_Enrollment({
            "elasticQueryName": "SPED_Enrollment",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchNet_Movement({
            "elasticQueryName": "Net_Movement",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchGraduation_To_KG_Enrollment_Ratio({
            "elasticQueryName": "Graduation_To_KG_Enrollment_Ratiodata",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));
        dispatch(fetchInter_School_Conversion({
            "elasticQueryName": "Inter_School_Conversion",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_Biggest_Gainers({
            "elasticQueryName": "Schools_Biggest_Gainers",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchSchools_Biggest_Losers({
            "elasticQueryName": "Schools_Biggest_Losers",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchTime_Analysis({
            "elasticQueryName": "Time_Analysis",
            "filters": [],
            "dynamicColumns": [],
        }));

        dispatch(fetchEnrollment_Time_Analysis({
            "elasticQueryName": "Enrollment_Time_Analysis",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

        dispatch(fetchKG_Grade12_Ratio({
            "elasticQueryName": "KG_Grade12_Ratio",
            "filters": [{
                "columnName": "SCHOOL_YEAR",
                "columnValue": "2027", 
                "excludeKeyword": false
            }],
            "dynamicColumns": [],
        }));

    }, [])
    useEffect(() => {
        const handleBeforeUnload = () => {
            window.sessionStorage.removeItem('enrollmentdimension');
            window.sessionStorage.removeItem('allfilter');
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    var defaultallfilter = JSON.parse(sessionStorage.getItem("allfilter"));

    useEffect(() => {
        let body;
        if (defaultallfilter) {
            body = {
                "elasticQueryName": "",
                "filters": defaultallfilter.filters,
                "dynamicColumns": [{ columnName: "#{dimension}", columnValue: [enrollment] }],
                "pivotConfig": [],

            };
        } else {
            body = {
                "elasticQueryName": "",
                "filters": [{
                    "columnName": "SCHOOL_YEAR",
                    "columnValue": "2027", "excludeKeyword": false
                }],
                "dynamicColumns": [{ columnName: "#{dimension}", columnValue: [enrollment] }],
                "pivotConfig": [],

            };
        }
        handleenrollment(body)
    }, [enrollment]);

    const handleenrollment = (body) => {
        dispatch(fetchEnrollment_Summary_By_Dimensions(body));
    }

    const [products, setProducts] = useState([]);
    const responsiveOptions = [
        {
            breakpoint: '1199px',
            numVisible: 5,
            numScroll: 5
        },
        {
            breakpoint: '991px',
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: '767px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    useEffect(() => {
        ProductService.getProductsSmall().then((data) => setProducts(data.slice(0, 9)));
    }, []);

    const timeAnalysis = (data, key) => {
        if (data && data.length) {
            let newMetric = [];
            let dataset = [];
            let new_obj = {};
            data.forEach(obj => {
                if (newMetric.indexOf(obj[key]) == -1) {
                    new_obj = obj;
                    var index = 0;
                    data.forEach(row => {
                        if (obj[key] == row[key]) {
                            let order = index + 1;
                            new_obj["category_" + order] = row["ENROLL_NUM"];
                            new_obj["category_label_" + order] = row["METRIC_NAME_UPDATED"];
                            index++;
                        }
                    });
                    dataset.push(new_obj);
                    newMetric.push(obj[key]);
                }
            });
            return dataset;
        }
    };
    var alertnew = JSON.parse(JSON.stringify(Time_Analysisdata));

    let dataset = timeAnalysis(alertnew, "SCHOOL_YEAR");
    if (dataset) {
        dataset = dataset.slice().sort((a, b) => {
            return a.SCHOOL_YEAR - b.SCHOOL_YEAR
        })
    }

    

    let new_arr = [];
    if (Enrollment_Summary_By_Dimensionsdata) {
        Enrollment_Summary_By_Dimensionsdata.forEach(n => {
            let isExist = false;

            new_arr.forEach(obj => {
                if (obj.DIMENSION == n.DIMENSION) {
                    obj.sum_total = obj.sum_total + n.METRIC_NUMERATOR;
                    isExist = true;
                }
            });

            if (!isExist) {
                new_arr.push({
                    DIMENSION: n.DIMENSION,
                    sum_total: n.METRIC_NUMERATOR,
                    GROUPBY_VARIANCE: n.GROUPBY_VARIANCE,
                    METRIC_INDICATOR_TYPE: n.METRIC_INDICATOR_TYPE,
                    METRIC_NUMERATOR_PY1: n.METRIC_NUMERATOR_PY1,
                    PERCENTAGE: n.PERCENTAGE
                });
            }

            if (enrollment === "student_grade") {
                const gradeOrder = ["Y5s", "K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
                new_arr.sort((a, b) => {
                    let gradeA = a?.DIMENSION?.replace("GRADE ", "");
                    let gradeB = b?.DIMENSION?.replace("GRADE ", "");
                    return (gradeOrder.indexOf(gradeA) !== -1 ? gradeOrder.indexOf(gradeA) : 99) -
                        (gradeOrder.indexOf(gradeB) !== -1 ? gradeOrder.indexOf(gradeB) : 99)
                })
            } else {
                new_arr.sort((a, b) => {
                    let gradeA = parseInt(a?.DIMENSION?.replace(/\D/g, ''), 10) || 0;
                    let gradeB = parseInt(b?.DIMENSION?.replace(/\D/g, ''), 10) || 0;
                    return gradeA - gradeB;
                });
            }
        });

        //   let maxCallback = (acc, cur) => Math.max(acc, cur);
        //   let maxValue = new_arr.map(el => el.sum_total).reduce(maxCallback);
        let maxCallback = (acc, cur) => Math.max(acc, cur);
        let maxValue = new_arr.map(el => el.sum_total);
        (new_arr || []).forEach(r => {
            r.sum_avg = (r.sum_total / maxValue) * 100;
        });

        new_arr.sort((a, b) => {
            return b.sum_avg - a.sum_avg;
        });

    }

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    const items = new_arr; // your array of items
    const totalPages = Math.ceil(items?.length / itemsPerPage);
    const handleNextClick = () => {
        setCurrentPage(currentPage === totalPages ? 1 : currentPage + 1);
    };
    const handlePrevClick = () => {
        setCurrentPage(currentPage === 1 ? totalPages : currentPage - 1);
    };

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = items?.slice(startIndex, endIndex);

    // const unique = [...new Set(dataset?.map(item => item["METRIC_NAME"]))]

    // const series = selectedOption != "Enrollment" ? [
    //     {
    //         name: 'Loss Count',
    //         type: 'bar',
    //         barWidth: "30%",
    //         color: '#E94F37',
    //         data: dataset?.map(item => ({
    //             value: item.category_1,
    //             year: item.SCHOOL_YEAR,
    //         })),
    //         emphasis: {
    //             focus: 'series',
    //         },
    //         itemStyle: {
    //             borderRadius: 8,
    //         },
    //     },
    //     {
    //         name: 'Drop Count',
    //         type: 'bar',
    //         barWidth: "30%",
    //         color: '#E94F37',
    //         data: dataset?.map(item => ({
    //             value: item?.category_1,
    //             year: item?.SCHOOL_YEAR,
    //         })),
    //         emphasis: {
    //             focus: 'series',
    //         },
    //         itemStyle: {
    //             borderRadius: 8,
    //         },
    //     }
    // ] : [{
    //     name: 'Total Enrollment',
    //     type: 'bar',
    //     barWidth: "30%",
    //     color: '#E99F4F',
    //     data: dataset?.map(item => ({
    //         value: item.category_2,
    //         year: item.SCHOOL_YEAR,
    //     })),
    //     emphasis: {
    //         focus: 'series',
    //     },
    //     itemStyle: {
    //         borderRadius: 8,
    //     },
    // }]



    const timeAnalysisChartdata = useMemo(() => {
        const x_labels = new Set();
        const group = Time_Analysisdata.reduce((acc, item) => { // group by METRIC_NAME_UPDATED data
            const { ENROLL_NUM, METRIC_NAME_UPDATED, SCHOOL_YEAR, PERCENTAGE } = item
            if (!acc[METRIC_NAME_UPDATED]) acc[METRIC_NAME_UPDATED] = {}
            if (!acc[METRIC_NAME_UPDATED][SCHOOL_YEAR]) {
                acc[METRIC_NAME_UPDATED][SCHOOL_YEAR] = {value: 0, percentage: 0}
                x_labels.add(SCHOOL_YEAR)
            }
            acc[METRIC_NAME_UPDATED][SCHOOL_YEAR]["value"] += ENROLL_NUM
            acc[METRIC_NAME_UPDATED][SCHOOL_YEAR]["percentage"] += PERCENTAGE
            return acc
        }, {})

        const _labels = [...x_labels]
        for (const name in group) {
            group[name] = _labels.map(year => group[name][year] ?? {})
        }

        return {
            labels: _labels,
            data: group 
        }
    }, [Time_Analysisdata]);

    const LossCountDescription = [
        "# of Students leaving in the current school year ( excluding Graduates)",
        "# of students who were enrolled at the end of previous school year but are no longer enrolled in the current school year"
    ];

    const CollectionTrend = {
            title: {},
            // tooltip: {
            //     trigger: 'item',
            //     backgroundColor: 'rgba(50,50,50,0.7)',
            //     borderColor: "#333",
            //     textStyle: {
            //         fontSize: 12,
            //         fontWeight: "normal",
            //         color: '#fff',
            //     },
            //     axisPointer: {
            //         type: 'shadow'
            //     }
            // },
            legend: {
                // left: '5%',
                // bottom: '0%',
                type: "plain",
                show: true,
                bottom: 0,
                left: '10%',
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    color: "rgba(255, 255, 255, 1)"
                }
            },
            tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(50,50,50,0.7)',
                borderColor: "#333",
                textStyle: {
                    fontSize: 12,
                    fontWeight: "normal",
                    color: '#fff',
                },
                extraCssText: 'max-width: 310px; white-space: normal;',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: (params) => {
                    let tooltipText = '';
                    params.forEach((param, i) => {
                        const { value, percentage } = param.data
                        if (selectedOption == 'Loss Count') {
                            if(!i) tooltipText += `${param?.axisValueLabel}`
                            tooltipText += percentage ? `<br/><br/><b>${param?.seriesName}</b> (${LossCountDescription[i]}) : <b> ${param?.value ?? "-"}(${percentage?.toFixed(1)}%)</b>` : `<br/>${param?.seriesName}: <b>-</b><br/>`
                        } else {
                            tooltipText = (`${param?.axisValueLabel}<br/>
                        ${param?.seriesName}: <b>${param?.value?.toLocaleString()}</b>`)
                        }
                    })

                    return tooltipText
                }
            },
            grid: {
                left: '5%',
                right: '5%',
                bottom: '10%',
                top: "10%",
                containLabel: true
            },
            yAxis: [
                {
                    type: 'value',
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#fff'
                        }
                    },
                    ...(
                        selectedOption == 'Loss Count' ?
                            {} :
                            {
                                min: function (value) {
                                    return Math.floor(value.min / 1000) * 1000;
                                }
                                // max: function (value) {
                                //     return value.max; // dataMax + 10
                                // },
                                // interval: 400,
                            }
                    ),

                    axisLabel: {
                        //   formatter: '${value}',
                        show: true,
                        color: '#fff'
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                            color: 'transparent'
                        },
                    },
                },

            ],
            xAxis: {
                type: 'category',
                data: timeAnalysisChartdata.labels,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff'
                    }
                },
                axisLabel: {
                    color: '#fff'
                },
            },
            color: ["#E99F4F", "#E94F37"],
            series: Object.entries(timeAnalysisChartdata.data).filter(([name]) => selectedOption != "Enrollment" ? name !== "Total Enrollment" :  name === "Total Enrollment").map(([name, data]) => {
                return {
                    name: name,
                    type: 'bar',
                    barWidth: "30%",
                    // color: '#E94F37',
                    data: data,
                    emphasis: {
                        focus: 'series',
                    },
                    label:{
                        show:true,
                        position: 'top',
                        "textStyle": {
                            "color": "#fff"
                          }
                    },
                    itemStyle: {
                        borderRadius: 8,
                    },
                }
            })
    }

    // const SpecialGroups = {
    //     title: {},
    //     tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         }

    //     },

    //     grid: {
    //         // left: -50,
    //         bottom: '0%',
    //         top: "20%",
    //         containLabel: true
    //     },
    //     legend: {
    //         orient: 'horizontal',
    //         // right: "-2%",
    //         left: "-2%",
    //         bottom: 'bottom',
    //         itemWidth: 6,
    //         itemHeight: 6,
    //         // top: '70%',
    //         // width:'220',
    //         itemGap: 4,
    //         textStyle: {
    //             color: "#fff",
    //             fontSize: '8',
    //             fontStyle: 'normal',

    //         }
    //     },
    //     series: [
    //         {
    //             name: 'Access From',
    //             type: 'pie',
    //             radius: '50%',
    //             avoidLabelOverlap: true,
    //             label: {
    //                 show: true,
    //                 position: 'left',
    //                 formatter: '{d}%',
    //                 position: 'inside',
    //                 textStyle: {
    //                     fontSize: '8',
    //                     color: "#fff"
    //                 }
    //             },
    //             emphasis: {
    //                 label: {
    //                     show: true,
    //                     fontSize: 9,
    //                     fontWeight: 'bold'
    //                 }
    //             },
    //             labelLine: {
    //                 show: false
    //             },
    //             data: [
    //                 {
    //                   value: Special_Groupdata[0]?.VALUE,
    //                   name: Special_Groupdata[0]?.KEY,
    //                   itemStyle:
    //                   {
    //                     color: '#377ab8'
    //                   }
    //                 },
    //                 {
    //                   value: Special_Groupdata[1]?.VALUE,
    //                   name: Special_Groupdata[1]?.KEY,
    //                   itemStyle:
    //                   {
    //                     color: '#6f2e66'
    //                   }
    //                 },
    //                 {
    //                   value: Special_Groupdata[2]?.VALUE,
    //                   name: Special_Groupdata[2]?.KEY,
    //                   itemStyle:
    //                   {
    //                     color: '#2c4990'
    //                   }
    //                 },
    //                 {
    //                   value: Special_Groupdata[3]?.VALUE,
    //                   name: Special_Groupdata[3]?.KEY,
    //                   itemStyle:
    //                   {
    //                     color: '#41a5ac'
    //                   }
    //                 },
    //               ]
    //         }
    //     ]
    // };
    // const EthnicityMix = {
    //     tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         }

    //     },
    //     legend: {
    //         orient: 'horizontal',
    //         // right: "-2%",
    //         itemGap: 4,
    //         left: "-2%",
    //         bottom: 'bottom',
    //         itemWidth: 6,
    //         itemHeight: 6,
    //         // top: '70%',
    //         // width: '250',

    //         textStyle: {
    //             color: "#fff",
    //             fontSize: '8',
    //             fontStyle: 'normal',

    //         }
    //     },
    //     series: [
    //         {
    //             name: 'Access From',
    //             type: 'pie',
    //             radius: ['20%', '50%'],
    //             avoidLabelOverlap: false,
    //             label: {
    //                 show: true,
    //                 position: 'left',
    //                 formatter: '{d}%',
    //                 position: 'inside',
    //                 textStyle: {
    //                     fontSize: '8',
    //                     color: "#fff"
    //                 }
    //             },
    //             emphasis: {
    //                 label: {
    //                     show: true,
    //                     fontSize: 9,
    //                     fontWeight: 'bold'
    //                 }
    //             },
    //             labelLine: {
    //                 show: false
    //             },
    //             data: [
    //                 {
    //                     value: Ethnicity_Mixdata[0]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[0]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                       color: '#377ab8'
    //                     }
    //                   },
    //                   {
    //                     value: Ethnicity_Mixdata[1]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[1]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                       color: '#6f2e66'
    //                     }
    //                   },
    //                   {
    //                     value: Ethnicity_Mixdata[2]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[2]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                       color: '#2c4990'
    //                     }
    //                   },
    //                   {
    //                     value: Ethnicity_Mixdata[3]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[3]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                       color: '#41a5ac'
    //                     }
    //                   },
    //                 {
    //                     value: Ethnicity_Mixdata[4]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[4]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                         color: '#393469'
    //                     }
    //                 },
    //                 {
    //                     value: Ethnicity_Mixdata[5]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[5]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                         color: '#6f2e66'
    //                     }
    //                 },
    //                 {
    //                     value: Ethnicity_Mixdata[6]?.GROUPBY_METRIC_NUMERATOR,
    //                     name: Ethnicity_Mixdata[6]?.STUDENT_ETHNICITY,
    //                     itemStyle:
    //                     {
    //                         color: '#359760'
    //                     }
    //                 }
    //             ]
    //         }
    //     ]
    // };

    // let metric_name = [...new Set(sortedSpecial_Groupdata?.map(item => item?.["METRIC_NAME"]))]
    // let colors = ["#6f2e66", "#377ab8", "#2c4990", "#41a5ac", "#393469"]

    // const SpecialGroup = {
    //     tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         },
    //         formatter: function (params) {
    //             const dataPoint = sortedSpecial_Groupdata.find(d => d.METRIC_NAME === params.seriesName);

    //             if (dataPoint) {
    //                 return `${params.marker} ${params.seriesName}: ${dataPoint.VALUE} (${dataPoint.PERCENTAGE}%)`;
    //             }
    //             return `${params.marker} ${params.seriesName}: ${params.value}`;
    //         }
    //     },
    //     grid: {
    //         left: '0%',
    //         bottom: '40%',
    //         top: "40%",
    //         right: '10%',
    //         height: '50%',
    //         containLabel: true
    //     },

    //     yAxis: [
    //         {
    //             type: 'category',
    //             position: "left",
    //             inverse: true,
    //             data: [],
    //             axisLine: {
    //                 show: false,
    //                 lineStyle: {
    //                     color: '#E3E3E3'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff',
    //                 fontSize: 11,
    //                 fontWeight: "normal",
    //                 position: 'insideLeft',
    //             },
    //             axisTick: {
    //                 show: false,
    //             },
    //         },
    //     ],

    //     xAxis: {
    //         show: false,
    //         inverse: true,
    //         // min: 0,
    //         // max: 20000,
    //         // interval: 10,
    //     },
    //     series: metric_name?.map((item, index) => {
    //         let borderRadius = {}
    //         if (index === 0) {
    //             borderRadius = {
    //                 barBorderRadius: [10, 10, 10, 10]
    //             }
    //         } else {
    //             borderRadius = {
    //                 barBorderRadius: [0, 10, 10, 0]
    //             }
    //         }

    //         return {
    //             name: item,
    //             label: {
    //                 show: false,
    //                 formatter: "{@VALUE}",
    //             },

    //             emphasis: {
    //                 focus: 'series'
    //             },
    //             stack: 'all',
    //             data: sortedSpecial_Groupdata?.filter(element => element?.["METRIC_NAME"] === item)?.map(it => it?.["VALUE"]),
    //             type: 'bar',
    //             barWidth: "80%",
    //             color: colors[index],
    //             itemStyle: {
    //                 normal: {
    //                     ...borderRadius,
    //                     // barBorderRadius: [3, 3, 3, 3],
    //                     color: colors[index],
    //                 }
    //             }

    //         }
    //     })
    // };
    // old single chart configuration
    const SpecialGroup = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            // formatter: function (params) {
            //     const dataPoint = sortedSpecial_Groupdata?.find(d => d.METRIC_NAME === params.name);

            //     if (dataPoint) {
            //       return `${params.marker} ${params.name}: <b>${dataPoint?.VALUE?.toLocaleString()} (${dataPoint.PERCENTAGE}%)</b>`;
            //     }
            //     return `${params.marker} ${params.name}: ${params.value}`;
            //   },
            formatter: function (params) {
                let tooltipText = '';
                params.forEach(item => {
                    // const dataPoint = sortedSpecial_Groupdata?.find(d =>
                    //     d.METRIC_NAME === item.name ||
                    //     (d.METRIC_NAME === "Emergent Bilingual" && item.name === "English Learners")
                    // );
                    const { value, percentage } = item.data
                    // if (dataPoint) {
                    if (percentage) {
                        tooltipText += `${item.marker} ${item.name}: <b>${value.toLocaleString()} (${percentage}%)</b><br/>`;
                    } else {
                        tooltipText += `${item.marker} ${item.name}: ${item.value?.toLocaleString()}<br/>`;
                    }
                });
                return tooltipText;
            },

            axisPointer: {
                type: 'shadow'
            },
            confine: true
        },
        grid: {
            left: '3%',
            bottom: '0%',
            top: "12%",
            right: '10%',
            height: '100%',
            containLabel: true
        },

        yAxis: [
            {
                type: 'category',
                position: "left",
                inverse: true,
                data: sortedSpecial_Groupdata?.map(itr => itr.METRIC_NAME === "Economically Disadvantaged" ? "Free and Reduced Lunch" : itr.METRIC_NAME == 'English Learners' ? 'EL' : itr.METRIC_NAME === "Special Ability" ? "Students with Disabilities"  : itr.METRIC_NAME),
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#E3E3E3'
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: '10',
                    fontWeight: "normal",
                    position: 'insideLeft',
                },
                axisTick: {
                    show: false,
                },
            },
        ],

        xAxis: {
            show: false,
            inverse: false,
            // min: 0,
            // max: 20000,
            // interval: 10,
        },

        series: [
            {
                label: {
                    normal: {
                        show: true,
                        position: "right",
                        fontSize: 10,
                        // padding: 10,
                        "formatter": function (params) {
                            return convertIntoCommaSeperated(params.value)
                        },
                        "textStyle": {
                            "color": "#fff"
                        }
                    }
                },
                emphasis: {
                    focus: 'series'
                },
                data: sortedSpecial_Groupdata?.map(itr => {
                    return {
                        value: itr.VALUE,
                        percentage: itr.PERCENTAGE ?? null
                    }
                }),
                type: 'bar',
                barWidth: "80%",
                // color: '#892c69',
                color: '#B55D5D',
                itemStyle: {
                    normal: {
                        barBorderRadius: [3, 3, 3, 3],
                        // color: '#892c69',
                        color: '#B55D5D',
                    }
                }

            }
        ]
    };

    const EthnicityMixs = {
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(50,50,50,0.7)',
            borderColor: "#333",
            textStyle: {
                fontSize: 12,
                fontWeight: "normal",
                color: '#fff',
            },
            axisPointer: {
                type: 'shadow'
            },
            confine: true,
            formatter:(params)=>{
                let tooltipContent = '';
                params.map((item, _i) =>{
                if(!_i) tooltipContent += `${item.axisValue}<br/>`
                tooltipContent += `${item.marker} ${item.seriesName}: <b>${item.value}</b><br/>`
                })
                tooltipContent += `Conversion Percentage : <b>${params?.[0]?.data.percent?.toFixed(1)}%</b><br/>`
                return tooltipContent
            }
        },
        grid: {
            left: '3%',
            bottom: '0%',
            top: "12%",
            right: screenWidth < 1200 ? '10%' : '3%',
            height: '85%',
            containLabel: true
        },

        yAxis: [
            {
                type: 'category',
                position: "left",
                inverse: true,
                data: sortedEthnicity_Mixdata.map(itr => itr.STUDENT_ETHNICITY),
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: '#E3E3E3'
                    }
                },
                axisLabel: {
                    color: '#fff',

                    fontSize: '10',
                    fontWeight: "normal",
                    position: 'insideLeft',
                },
                axisTick: {
                    show: false,
                },
            },
        ],

        xAxis: {
            show: false,
            inverse: false,
        },

        series: [
            {
                name: "School Going Population",
                data: sortedEthnicity_Mixdata.map(itr => {
                    return {
                        value: itr.GROUPBY_METRIC_NUMERATOR,
                        percent: itr.CONVERSION_PERCENTAGE
                    }
                }),  // Student Count Series
                type: 'bar',
                barWidth: '65%',  // Total population bar width
                itemStyle: {
                    color: "#b65d59",
                    borderRadius: [0, 6, 6, 0],
                },
                label: {
                    show: true,
                    position: 'right',
                    formatter: params => params.value?.toLocaleString(),
                    textStyle: {
                        color: "#fff",
                        fontSize: 10,
                    },
                    offset: [10, 0],
                },

                z: 1,  // Lower z-index so it's behind the student count
            },
            {
                name: 'Actual Enrollment',
                data: sortedEthnicity_Mixdata.map(itr => {
                    return {
                        value: itr.STUDENT_COUNT,
                        percent: itr.CONVERSION_PERCENTAGE
                    }
                }),
                type: 'bar',
                barGap: '-80%',  // Ensures the bars overlap
                barWidth: '40%',  // Student count bar width, narrower than the total population
                itemStyle: {
                    color: "#c79b27",
                    borderRadius: [0, 6, 6, 0],
                },
                label: {
                    show: false,
                    position: 'insideLeft',
                    formatter: params => params.value,
                    textStyle: {
                        color: "#fff",
                        fontSize: 10,
                    },
                },
                z: 2,  // Higher z-index to be on top of the total population
            },

        ],

    };


    const MyChart = React.memo(({ options }) => {
        return <ReactEcharts option={options} notMerge={true} lazyUpdate={true} style={{ width: '100%', height: 155, margin: 'auto' }} />;
    });



    // let student_ethnicity = [...new Set(sortedEthnicity_Mixdata?.map(item => item?.["STUDENT_ETHNICITY"]))]
    // let student_ethnicity_colors = ["#6f2e66", "#377ab8", "#2c4990", "#41a5ac", "#393469"]

    // const EthnicityMixs = {
    //     tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         },
    //         formatter: function (params) {
    //             const dataPoint = sortedEthnicity_Mixdata.find(d => d.STUDENT_ETHNICITY === params.seriesName);

    //             if (dataPoint) {
    //                 return `${params.marker} ${params.seriesName}: ${dataPoint.GROUPBY_METRIC_NUMERATOR} (${dataPoint.PERCENTAGE}%)`;
    //             }
    //             return `${params.marker} ${params.seriesName}: ${params.value}`;
    //         }
    //     },
    //     grid: {
    //         left: '3%',
    //         bottom: '40%',
    //         top: "40%",
    //         right: '10%',
    //         height: '50%',
    //         containLabel: true
    //     },

    //     yAxis: [
    //         {
    //             type: 'category',
    //             position: "left",
    //             inverse: true,
    //             data: [],
    //             axisLine: {
    //                 show: false,
    //                 lineStyle: {
    //                     color: '#E3E3E3'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff',
    //                 fontSize: 11,
    //                 fontWeight: "normal",
    //                 position: 'insideLeft',
    //             },
    //             axisTick: {
    //                 show: false,
    //             },
    //         },
    //     ],

    //     xAxis: {
    //         show: false,
    //         inverse: true,
    //         // min: 0,
    //         // max: 50000,
    //         // interval: 10,
    //     },

    //     series: student_ethnicity?.map((item, index) => {
    //         let borderRadius = {}
    //         if (index === 0) {
    //             borderRadius = {
    //                 barBorderRadius: [10, 10, 10, 10]
    //             }
    //         } else if (sortedEthnicity_Mixdata?.length - 1 === index) {
    //             borderRadius = {
    //                 barBorderRadius: [0, 10, 10, 0]
    //             }
    //         } else {
    //             borderRadius = {
    //                 barBorderRadius: [0, 10, 10, 0]
    //             }
    //         }

    //         return {
    //             name: item,
    //             label: {
    //                 show: false,
    //                 formatter: "{@VALUE}",
    //             },

    //             emphasis: {
    //                 focus: 'series'
    //             },
    //             stack: 'all',
    //             data: sortedEthnicity_Mixdata?.filter(element => element?.["STUDENT_ETHNICITY"] === item)?.map(it => it?.["GROUPBY_METRIC_NUMERATOR"]),
    //             type: 'bar',
    //             barWidth: "80%",
    //             color: student_ethnicity_colors[index],
    //             itemStyle: {
    //                 normal: {
    //                     ...borderRadius,
    //                     // barBorderRadius: [3, 3, 3, 3],
    //                     color: colors[index],
    //                 }
    //             }

    //         }
    //     })
    // };


    // old single chart configuration
    // const EthnicityMixs = {
    //     tooltip: {
    //         trigger: 'item',
    //         backgroundColor: 'rgba(50,50,50,0.7)',
    //         borderColor: "#333",
    //         textStyle: {
    //             fontSize: 12,
    //             fontWeight: "normal",
    //             color: '#fff',
    //         },
    //         axisPointer: {
    //             type: 'shadow'
    //         },
    //         formatter: function (params) {
    //             const dataPoint = sortedEthnicity_Mixdata.find(d => d.STUDENT_ETHNICITY === params.name);

    //             if (dataPoint) {
    //                 return `${params.marker} ${params.name}: ${dataPoint.GROUPBY_METRIC_NUMERATOR} (${dataPoint.PERCENTAGE}%)`;
    //             }
    //             return `${params.marker} ${params.name}: ${params.value}`;
    //         }
    //     },
    //     grid: {
    //         left: '3%',
    //         bottom: '0%',
    //         top: "22%",
    //         right: '10%',
    //         height: '85%',
    //         containLabel: true
    //     },

    //     yAxis: [
    //         {
    //             type: 'category',
    //             position: "left",
    //             inverse: true,
    //             data: sortedEthnicity_Mixdata.map(itr => itr.STUDENT_ETHNICITY),
    //             axisLine: {
    //                 show: false,
    //                 lineStyle: {
    //                     color: '#E3E3E3'
    //                 }
    //             },
    //             axisLabel: {
    //                 color: '#fff',
    //                 fontSize: 11,
    //                 fontWeight: "normal",
    //                 position: 'insideLeft',
    //             },
    //             axisTick: {
    //                 show: false,
    //             },
    //         },
    //     ],

    //     xAxis: {
    //         show: false,
    //         inverse: false,
    //         // min: 0,
    //         // max: 50000,
    //         // interval: 10,
    //     },

    //     series: [
    //         {
    //             label: {
    //                 normal: {
    //                     show: true,
    //                     position: "right",
    //                     fontSize: 11,
    //                     // padding: 10,
    //                     "formatter": function (params) {
    //                         return params.value.GROUPBY_METRIC_NUMERATOR
    //                     },
    //                     "textStyle": {
    //                         "color": "#fff"
    //                     }
    //                 }
    //             },
    //             emphasis: {
    //                 focus: 'series'
    //             },
    //             data: sortedEthnicity_Mixdata.map(itr => itr.GROUPBY_METRIC_NUMERATOR),
    //             type: 'bar',
    //             barWidth: "80%",
    //             color: '#892c69',
    //             itemStyle: {
    //                 normal: {
    //                     barBorderRadius: [3, 3, 3, 3],
    //                     color: '#892c69',
    //                 }
    //             }

    //         }
    //     ]
    // };

    const enrollData = {
        yaxis: ["Telco"],
        value1: Enrollmentdata?.map(item => item["METRIC_NUMERATOR"]),
        value: School_Going_Populationdata?.map(item => item["SCHOOL_GOING_POPULATION"])
    }
    const enrollData1 = {
        yaxis: ["Telco"],
        value: SPED_Enrollmentdata?.map(item => item["METRIC_NUMERATOR"]),
        value1: SPED_Enrollmentdata?.map(item => item["ADJUSTMENTS"])
    }

    const handleEnrollment = (e) => {
        setEnrollment(e.value)
        setCurrentPage(1)
    }

    const TooltipAttributes = ({ categoryLabel, title }) => {
        return {
            'data-pr-tooltip': `Variance from Last Year ${title == 'Inter-School Conversion' ? categoryLabel?.toFixed(1) : categoryLabel?.toLocaleString()}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            // 'data-pr-className': 'custom-tooltip',
            style: { fontSize: '0rem', cursor: 'pointer' }
        }
    }
    const TooltipAttributes1 = ({ Description }) => {
        return {
            'data-pr-tooltip': `${Description}`,
            'data-pr-position': 'top',
            'data-pr-my': 'left-40 bottom',
            'data-pr-at': 'center top-5',
            // 'data-pr-className': 'custom-tooltip',
            style: { cursor: 'pointer' }
        }
    }

    const GraduationKgEnrollmentRatio_Desc = [
        "The total number of students graduates in the prior school year.",
        "The total number of students enrolled in Kindergarten in the current school year."
    ]

    return (
        <div className="pb-5 body Enrollmentbody">
            <TopNav pagename="Enrollment" pagenamedescription="Key Facts about the District" setUserData={props.setUserData} />
            <AppliedFilters pagename={"Enrollment"}/>
            <div className="movement-container ">
                <div className="grid grid-cols-12 gap-3 mx-8">
                    <div className="col-span-4 ">
                        <LoaderContainer height={"180px"} width={"100%"} loading={Enrollmentloading} className="FinInfo1">
                            <div className="basic-container-child lg:h-[215px]">
                                <Tooltip target=".custom-target-icon" />
                                <div className="custom-target-icon w-10" {...TooltipAttributes1({ Description: "Number of students currently enrolled" })}>
                                    <span className="!text-white text-sm">Enrollment</span>
                                </div>
                                <div className="text-white text-[10px]">[Pre-K to 12 Grade]</div>

                                <div className="flex items-center justify-start">
                                    <div className="text-white text-lg">{Enrollmentdata[0]?.METRIC_NUMERATOR?.toLocaleString()}</div>
                                    <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: Enrollmentdata[0]?.METRIC_NUMERATOR_PY1 })}>
                                        {

                                            Enrollmentdata[0]?.GROUPBY_VARIANCE >= 0 ?
                                                // <div className="bg-[#1C6130] text-xs text-white px-1 rounded-full w-auto h-4 ml-5 flex items-center"><img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /> {Enrollmentdata[0]?.GROUPBY_VARIANCE?.toFixed(2)}% from Last Year</div>
                                                <div className="bg-[#129C83] text-xs text-white px-1 rounded-full w-auto h-4 ml-5 flex items-center"> {(Number(Enrollmentdata[0]?.GROUPBY_VARIANCE).toFixed(1)) + "%"} <img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                :
                                                // <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 ml-5 flex items-center"><img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /> {Enrollmentdata[0]?.GROUPBY_VARIANCE?.toFixed(2)}% from Last Year</div>
                                                <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 ml-5 flex items-center"> {(Number(Enrollmentdata[0]?.GROUPBY_VARIANCE).toFixed(1)) + "%"} <img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                        }
                                    </div>

                                </div>
                                <div className="grid grid-cols-2 gap-2 flex items-center mt-2">
                                    <div className="col-span-1">
                                        <div className="flex items-center justify-evenly">
                                            <div className="rounded full h-2 w-2 bg-[#d46c58]"></div>
                                            {/* <div className="px-2 py-1">
                                                <div className="text-white text-[11px] font-[300]">Enrollment Projections</div>
                                                <div className="text-white text-sm">{Enrollmentdata[0]?.ENROLLMENT_PROJECTION?.toLocaleString()}</div>
                                            </div> */}
                                            <div className="px-2 py-1">
                                                <div className="custom-target-icon" {...TooltipAttributes1({ Description: "The potential student population in the attendance boundary." })}>
                                                    <div className="text-white text-[11px] font-[300]">School Going Population</div>
                                                </div>
                                                <div className="text-white text-sm">{School_Going_Populationdata[0]?.SCHOOL_GOING_POPULATION?.toLocaleString()}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-span-1">
                                        <div className="flex items-center justify-evenly">
                                            <div className="rounded full h-2 w-2 bg-[#ea9e50]"></div>
                                            <div className="px-2 py-1">
                                                <div className="custom-target-icon" {...TooltipAttributes1({ Description: "Number of students currently enrolled " })}>
                                                    <div className="text-white text-[11px] font-[300]">Actual Enrollment</div>
                                                </div>
                                                <div className="text-white text-sm">{Enrollmentdata[0]?.METRIC_NUMERATOR?.toLocaleString()}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-span-1">
                                        <div className="flex items-center justify-evenly">
                                            <div className="rounded full h-2 w-2 bg-[#892a69]"></div>
                                            <div className="px-2 py-1">
                                                <div className="text-white text-[11px] font-[300]">Adjustments</div>
                                                <div className="text-white text-sm">{Enrollmentdata[0]?.ADJUSTMENTS?.toLocaleString()}</div>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="my-2">
                                    <div className="bg-[#0F0D0B] px-1 rounded-[10px] h-[3rem]">
                                        {/* <ProgressBar className="relative h-5" labelClassName="progresslbl" completed={Enrollmentdata[0]?.METRIC_NUMERATOR} bgColor="#149c83" borderRadius="10px" baseBgColor="#892a69" /> */}
                                        <HorizontalStackBars
                                            barWidth='8'
                                            data={enrollData}
                                            names={["School Going Population", "Actual Enrollment"]}
                                            grid={{
                                                "left": '0%',
                                                "top": '0%',
                                                "right": '0%',
                                                "bottom": '10px',
                                                // "containLabel": "true"
                                            }}
                                        />
                                    </div>
                                <div className="!z-50 text-white text-[12px] mb-2">Data source: <a href="https://censusreporter.org/" target="_blank" rel="noopener noreferrer" className="underline text-blue-500">https://censusreporter.org/</a></div>
                                </div>
                            </div>
                        </LoaderContainer>
                    </div>
                    <div className="col-span-4">
                        <LoaderContainer height={"180px"} width={"100%"} loading={Ethnicity_Mixloading} className="FinInfo1">
                            <div className="basic-container-child">
                                <div className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Distribution of potential student population across different age ranges" })}>
                                    <div className="text-white text-sm">Age Groups</div>
                                </div>
                                <div className='mt-0'>
                                    <MyChart options={EthnicityMixs} />
                                    {/* <ReactEcharts option={EthnicityMixs} style={{ width: 375, height: 175, margin: 'auto' }} /> */}
                                    <div className="text-white text-[12px]">Data source: <a href="https://censusreporter.org/" target="_blank" rel="noopener noreferrer" className="underline text-blue-500">https://censusreporter.org/</a></div>
                                </div>
                            </div>
                        </LoaderContainer>
                    </div>
                    <div className="col-span-4">
                        <LoaderContainer height={"180px"} width={"100%"} loading={Special_Grouploadingdata} className="FinInfo1">
                            <div className="basic-container-child h-full px-1">
                                <div className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Categorization of students belonging to different special groups" })}>
                                    <div className="text-white text-sm">Special Groups</div>
                                </div>
                                <div className='mt-0'>
                                    <MyChart options={SpecialGroup} />
                                    {/* <ReactEcharts option={SpecialGroup} style={{ width: 375, height: 170, margin: 'auto' }} /> */}
                                </div>
                            </div>
                        </LoaderContainer>
                    </div>

                </div>
            </div>
            <div className="movement-container">
                <div className="grid grid-cols-3 gap-4 xl:gap-8">
                    <div className="col-span-1 z-50">
                        <LoaderContainer height={"100px"} width={"100%"} loading={Net_Movementloadingdata} className="FinInfo1">
                            <div className="flex gap-3">
                                <div className="text-sm text-white ml-0 my-2">Net Movement</div>
                                <InfoWithOverlay
                                    // content={'Net Movement indicates the overall change in district enrollment by measuring the balance between students entering and leaving during the selected period. This includes graduating seniors who exit the district as part of student losses and incoming kindergarteners who are counted as newly enrolled students.'}
                                    content2={Net_MovementOrderedData?.map((item, idx) =>
                                        <div key={idx}>
                                            <strong>{item?.METRIC_NAME}</strong>: {item?.METRIC_NAME == 'Total Net Movement of Students' ? 'Net Movement indicates the overall change in district enrollment by measuring the balance between students entering and leaving during the selected period. This includes graduating seniors who exit the district as part of student losses and incoming kindergarteners who are counted as newly enrolled students.' : item?.METRIC_DESCRIPTION}
                                        </div>
                                    )} />
                            </div>
                            <div className="flex gap-2 xl:gap-4">
                                <img src={students} width="40px" height="65px" style={{ margin: 'auto' }} />
                                <div className="w-full">
                                    {Net_MovementOrderedData?.map((item, index) => {
                                        return (
                                            <div className="grid grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 mb-1" style={{ borderBottom: '1px solid rgb(92, 120, 132)' }}>
                                                <div className="col-span-3 lg:col-span-4 xl:col-span-6">
                                                    <div className="custom-target-icon" {...TooltipAttributes1({ Description: item?.METRIC_NAME == 'Total Net Movement of Students' ? 'Net Movement indicates the overall change in district enrollment by measuring the balance between students entering and leaving during the selected period. This includes graduating seniors who exit the district as part of student losses and incoming kindergarteners who are counted as newly enrolled students.' : item?.METRIC_DESCRIPTION })}>
                                                        <div className="text-xs text-white">{item?.METRIC_NAME}</div>
                                                    </div>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="text-sm text-white">{item?.METRIC_NUMERATOR?.toLocaleString()}</div>
                                                </div>
                                                <div className="col-span-1">
                                                    <Tooltip target=".custom-target-icon" />
                                                    <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: item?.METRIC_NUMERATOR_PY1 })}>
                                                        {
                                                            item?.METRIC_ID == 10062 ?
                                                                item?.METRIC_NUMERATOR <= item?.METRIC_NUMERATOR_PY1 ?
                                                                    <div className="bg-[#129C83] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center" style={{ width: '50px' }}> {Number(item?.GROUPBY_VARIANCE).toFixed(1)}%
                                                                        <img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                    </div> :
                                                                    <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full  h-4 ml-0 flex items-center justify-center" style={{ width: "50px" }}> {Number(item?.GROUPBY_VARIANCE).toFixed(1)}%
                                                                        <img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                    </div>
                                                                :
                                                                item?.GROUPBY_VARIANCE >= 0 ?
                                                                    <div className="bg-[#129C83] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center" style={{ width: '50px' }}> {Number(item?.GROUPBY_VARIANCE).toFixed(1)}%
                                                                        <img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                    </div> :
                                                                    <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full  h-4 ml-0 flex items-center justify-center" style={{ width: "50px" }}> {Number(item?.GROUPBY_VARIANCE).toFixed(1)}%
                                                                        <img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                    </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )

                                    })}

                                </div>
                            </div>
                        </LoaderContainer>
                    </div>
                    <div className="col-span-1">
                        <LoaderContainer height={"100px"} width={"100%"} loading={Graduation_To_KG_Enrollment_Ratioloadingdata} className="FinInfo1">
                            <div className="flex gap-3">
                                <div className="text-sm text-white ml-0 my-2 custom-target-icon w-fit" {...TooltipAttributes1({ Description: "The ratio of students graduating in the previous school year to those enrolling in Kindergarten(KG) in the current school year" })}>Graduation to KG Enrollment Ratio</div>
                                <InfoWithOverlay
                                    content={'Provides insight into long-term enrollment sustainability by comparing the number of students graduating from Grade 12 with the number of new Kindergarten entrants.'}
                                    content2={Graduation_To_KG_Enrollment_Ratiodata?.map((item, idx) =>
                                        <div key={idx}>
                                            <strong>{item?.METRIC_NAME === "Total KDG Enrollment" ? "Total KG Enrollment" : item?.METRIC_NAME}</strong>: {GraduationKgEnrollmentRatio_Desc[idx]}
                                        </div>
                                    )} />
                            </div>
                            <div className="flex gap-2 xl:gap-4">
                                <div className="text-white text-xl flex justify-center"> {KG_Grade12_Ratiodata?.[0]?.RATIO ?? '-'}</div>
                                <div className="w-full">

                                    {Graduation_To_KG_Enrollment_Ratiodata.map((item, index) => {
                                        return (
                                            <div className="grid grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 mb-1" style={{ borderBottom: '1px solid rgb(92, 120, 132)' }}>
                                                <div className="col-span-3 lg:col-span-4 xl:col-span-6">
                                                    <div className="text-xs text-white flex items-center">
                                                        <i className="pi pi-arrow-left mx-1"></i>
                                                        <img src={Studentgrp} width={20} height={20} className="mx-1" />
                                                        <div className="custom-target-icon" {...TooltipAttributes1({ Description: GraduationKgEnrollmentRatio_Desc[index] })}>
                                                            <span>{item?.METRIC_NAME === "Total KDG Enrollment" ? "Total KG Enrollment" : item?.METRIC_NAME}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-span-1">
                                                    <div className="text-sm text-white">{item?.METRIC_ID == '10031' ? ((item?.METRIC_NUMERATOR_PY1 || null)?.toLocaleString() ?? "-") : ((item?.METRIC_NUMERATOR || null)?.toLocaleString() ?? "-")}</div>
                                                </div>
                                                <div className="col-span-1">
                                                    {/* <div className="bg-[#129c83] text-xs text-white px-1 rounded-full w-auto h-4 ml-0 flex items-center justify-between">{Graduation_To_KG_Enrollment_Ratiodata?.[0]?.GROUPBY_VARIANCE.toFixed(1)}%<img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /></div> */}
                                                    <Tooltip target=".custom-target-icon" />
                                                    <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: item?.METRIC_NUMERATOR_PY1 })}>
                                                        {
                                                            item?.GROUPBY_VARIANCE >= 0 ?
                                                                <div style={{ width: "60px" }} className="bg-[#129C83] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center"> {(item?.GROUPBY_VARIANCE || null)?.toFixed(1) ?? "-"}%
                                                                    {/* <div style={{ width: "55px" }} className="bg-[#1C6130] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center">NA */}
                                                                    <img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                </div> :
                                                                <div style={{ width: "60px" }} className="bg-[#d46c58] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center"> {item?.GROUPBY_VARIANCE?.toFixed(1)}%
                                                                    {/* <div style={{ width: "55px" }} className="bg-[#d46c58] text-xs text-white px-1 rounded-full h-4 ml-0 flex items-center justify-center">NA */}
                                                                    <img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" />
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}

                                </div>
                            </div>
                        </LoaderContainer>
                    </div>
                    <div className="col-span-1">
                        <LoaderContainer height={"100px"} width={"100%"} loading={Inter_School_Conversionloadingdata} className="FinInfo1">
                            <div className="flex gap-3">
                                <div className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Percentage of students transitioning from one school level to the next, reflecting retention and progression rates across different school stages." })}>
                                    <div className="text-sm text-white ml-0 my-2">Inter-School Conversion</div>
                                </div>
                                <InfoWithOverlay
                                    content={'Measures the effectiveness of student progression between school levels (e.g., Early Education → Elementary, Elementary → Middle).'}
                                    content2={Inter_School_Conversiondata?.map((item, idx) =>
                                        <div key={idx}>
                                            <strong>{item?.METRIC_NAME}</strong>: {item?.METRIC_DESCRIPTION}
                                        </div>
                                    )} />
                            </div>
                            <div className="flex gap-2 xl:gap-4">
                                <img src={school} width="50px" height="50px" style={{ margin: 'auto' }} />
                                <div className="w-full">
                                    {
                                        Inter_School_Conversiondata.map((item, index) => {
                                            return (
                                                <div className="grid grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 mb-1" style={{ borderBottom: '1px solid rgb(92, 120, 132)' }}>
                                                    <div className="col-span-3 lg:col-span-4 xl:col-span-6">
                                                        <div className="custom-target-icon" {...TooltipAttributes1({ Description: item?.METRIC_DESCRIPTION })}>
                                                            <div className="text-xs text-white">{item?.METRIC_NAME}</div>
                                                        </div>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <div className="text-sm text-white">{item?.METRIC_NUMERATOR?.toFixed(1)}%</div>
                                                    </div>
                                                    <div className="col-span-1">
                                                        <Tooltip target=".custom-target-icon" />
                                                        <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: item?.METRIC_NUMERATOR_PY1, title: 'Inter-School Conversion' })}>
                                                            {
                                                                item?.GROUPBY_VARIANCE >= 0 ?
                                                                    <div style={{ width: "50px" }} className="bg-[#129C83] text-xs text-white px-1 rounded-full w-auto h-4 ml-0 flex items-center justify-center"> {item?.GROUPBY_VARIANCE?.toFixed(1)}%
                                                                        {/* <div style={{ width: "50px" }} className="bg-[#1C6130] text-xs text-white px-1 rounded-full w-auto h-4 ml-0 flex items-center justify-between">{"NA"}% */}
                                                                        <img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /></div> :
                                                                    <div style={{ width: "50px" }} className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 ml-0 flex items-center justify-center"> {item?.GROUPBY_VARIANCE?.toFixed(1)}%<img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                                // <div style={{ width: "50px" }} className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 ml-0 flex items-center justify-between">{"NA"}<img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })
                                    }


                                </div>
                            </div>
                        </LoaderContainer>
                    </div>
                </div>
            </div>

            <div className='grid grid-cols-12 mx-5 mt-2 gap-3 pt-8'>
                <div className='col-span-4 xl:col-span-6'>
                    <div className='echart h-full relative wrap-component'>
                        {/* <div className="title-text flex items-center text-white ml-5 py-5">Time Analysis</div> */}
                        <div className="flex justify-between mx-2 my-2 items-center">
                            <div className="text-md text-white">Time Analysis</div>
                            <div className="flex justify-center enrollselect" >
                                <div className="flex gap-4 mt-2">
                                    <div className="flex items-center">
                                        <RadioButton
                                            inputId="firstOption"
                                            name="viewOption"
                                            value="Enrollment"
                                            onChange={(e) => setSelectedOption(e.value)}
                                            checked={selectedOption === 'Enrollment'}
                                        />
                                        <label htmlFor="firstOption" className="ml-2 text-white text-[15px]">Enrollment</label>
                                    </div>

                                    <div className="flex items-center">
                                        <RadioButton
                                            inputId="secondOption"
                                            name="viewOption"
                                            value="Loss Count"
                                            onChange={(e) => setSelectedOption(e.value)}
                                            checked={selectedOption === 'Loss Count'}
                                        />
                                        <label htmlFor="secondOption" className="ml-2 text-white text-[15px]">Loss Count</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='relative'>
                            <LoaderContainer height={"250px"} width={"100%"} loading={Time_Analysisloadingdata} className="relative">
                                <ReactEcharts option={CollectionTrend} notMerge />
                                <div className='yaxis-text absolute top-[40%] left-[-30px] xl:left-[-20px] text-[#fff]'>Enrollment</div>
                            </LoaderContainer>
                        </div>
                    </div>
                </div>
                <div className="card col-span-4 xl:col-span-3 wrap-component relative">
                    <div className="flex justify-between mx-2 my-2 items-center">
                        <div className="text-md text-white">Enrollment Summary</div>
                        <div className="flex justify-center enrollselect" >
                            <Dropdown value={enrollment} onChange={handleEnrollment} options={options} optionLabel="name"
                                placeholder="View by Gender" className="w-full md:w-14rem text-xs" style={{ width: 180 }} />
                        </div>
                    </div>
                    <LoaderContainer height={"250px"} width={"100%"} loading={Enrollment_Summary_By_Dimensionsloadingdata} className="relative">

                        <div className="px-2 pt-5">
                            {currentItems && currentItems?.map(itr => {
                                return (
                                    <div className="my-2">
                                        <div className="relative" data-pr-tooltip={`${itr?.DIMENSION == 'Qualified Free' ? 'Free and Reduced Lunch' : itr?.DIMENSION}: ${itr?.PERCENTAGE?.toFixed(1)+'%'}`} data-pr-position="top">
                                            <ProgressBar labelClassName="progresslabeltext py-2" completed={itr?.sum_total} customLabel={itr?.sum_total.toLocaleString()} minCompleted={0} maxCompleted={10000} bgColor="linear-gradient(90deg,rgb(181, 93, 92) 0%, rgb(199, 155, 39) 100%)" borderRadius="10px" baseBgColor="#32395699" />
                                        </div>
                                        <Tooltip target="[data-pr-tooltip]" />
                                        <div className="text-white text-[10px] xl:text-xs mx-2 mt-[-19px] absolute">{itr?.DIMENSION == 'Qualified Free' ? 'Free and Reduced Lunch' : itr?.DIMENSION}</div>
                                        <Tooltip target=".custom-target-icon" />
                                        <div className="custom-target-icon" {...TooltipAttributes({ categoryLabel: itr?.METRIC_NUMERATOR_PY1 })}>
                                            {
                                                itr?.GROUPBY_VARIANCE == 0 ?
                                                    <div className="bg-[#129C83] text-xs text-white px-1 rounded-full w-auto h-4 mt-[-19px] absolute right-[-10%]  flex items-center" style={{ right: "0.5rem" }}> - %</div>
                                                    : itr?.GROUPBY_VARIANCE > 0 ?
                                                        <div className="bg-[#129C83] text-xs text-white px-1 rounded-full w-auto h-4 mt-[-19px] absolute right-[-10%]  flex items-center" style={{ right: "0.5rem" }}> {itr?.GROUPBY_VARIANCE?.toFixed(1)}%<img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                        // <div className="bg-[#1C6130] text-xs text-white px-1 rounded-full w-auto h-4 mt-[-19px] absolute right-[-10%]  flex items-center" style={{ right: "0.5rem" }}>{"NA"}<img src={caretup} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                        :
                                                        <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 mt-[-19px] absolute right-[-10%]  flex items-center" style={{ right: "0.5rem" }}> {itr?.GROUPBY_VARIANCE?.toFixed(1)}%<img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                                    // <div className="bg-[#d46c58] text-xs text-white px-1 rounded-full w-auto h-4 mt-[-19px] absolute right-[-10%]  flex items-center" style={{ right: "0.5rem" }}>{"NA"}<img src={caretdown} width={5} height={5} className="inline-block ml-1" alt="" /></div>
                                            }
                                        </div>

                                    </div>
                                )
                            })}


                        </div>
                    </LoaderContainer>
                    <div className='pagination'>
                        <a class="inline-flex items-center px-4 py-2 mr-3 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                            <button className={`paginationprevious ${currentPage === 1 ? 'disabled' : ''}`} onClick={handlePrevClick} disabled={currentPage === 1}><img src={RightArrow} className="rotate-180" width="12" /></button> {currentPage} </a>
                        <span>of</span>
                        <a class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                            {totalPages} <button className={`paginationnext ${currentPage === totalPages ? 'disabled' : ''}`} onClick={handleNextClick} disabled={currentPage === totalPages}><img src={RightArrow} className="" width="12" /></button></a>
                    </div>
                </div>
                <div className="card col-span-4 xl:col-span-3 wrap-component">
                    <div className="text-md text-white my-2 mx-2">Schools</div>
                    <div className="px-2  ">
                        <div className="bg-[#0F0D0B] rounded-[10px] px-1 py-2 my-1">
                            <div className="custom-target-icon w-fit" {...TooltipAttributes1({ Description: "Schools with the highest increase in student enrollment year over year." })}>
                                <div className="text-xs text-white">Biggest Gainers Compared To Last Year</div>
                            </div>
                            <LoaderContainer height={"100px"} width={"100%"} loading={Schools_Biggest_Gainersloading} className="relative">
                                <Tooltip target="[data-pr-tooltip]" />
                                {Schools_Biggest_Gainersdata?.map((school, index) => (
                                    <div key={index} className="my-2" data-pr-tooltip={`${school?.SCHOOL_OFFICIAL_NAME}: ${school?.PERCENTAGE?.toFixed(1)+'%'} (${school?.METRIC_NUMERATOR})`} data-pr-position="top">
                                        <ProgressBar
                                            className="relative"
                                            labelClassName="progresslabeltext1"
                                            completed={school?.PERCENTAGE}
                                            maxCompleted={100}
                                            customLabel={`${school?.PERCENTAGE?.toFixed(1)}%`}
                                            bgColor="#c79b27"
                                            borderRadius="10px"
                                            baseBgColor="#32395699"
                                        />
                                        <div className="text-white text-[10px] xl:text-xs mx-2 mt-[-19px] absolute">
                                            {school.SCHOOL_OFFICIAL_NAME}
                                        </div>
                                    </div>
                                ))}
                            </LoaderContainer>
                        </div>
                        <div className="bg-[#0F0D0B] rounded-[10px] px-1 py-2 my-1">
                            <div className="text-xs text-white text-right custom-target-icon" {...TooltipAttributes1({ Description: "# of students who were enrolled at the end of previous school year but are no longer enrolled in the current school year." })}>Schools With Most Loss Compared To Last Year</div>
                            <LoaderContainer height={"100px"} width={"100%"} loading={Schools_Biggest_Losersloadingdata} className="relative">
                                <Tooltip target="[data-pr-tooltip]" />
                                {Schools_Biggest_Losersdata?.map((school, index) => (
                                    <div key={index} className={`my-2 ${index === 0 ? 'mb-2 mt-0.5' : ''}`} data-pr-tooltip={`${school?.SCHOOL_OFFICIAL_NAME}: ${school?.PERCENTAGE?.toFixed(1)+'%'} (${school?.METRIC_NUMERATOR})`} data-pr-position="top">
                                        <ProgressBar
                                            className={`relative ${index === 0 ? 'ml-[90px]' : index === 1 ? 'ml-[20px]' : ''}`}
                                            labelClassName="progresslabeltext1"
                                            completed={school.SCHOOL_OFFICIAL_NAME}
                                            bgColor="#B55D5D"
                                            borderRadius="10px"
                                            baseBgColor={index === 0 ? 'transparent' : '#32395699'}
                                        />
                                        <div className="text-white text-[10px] xl:text-xs mx-2 mt-[-19px] absolute">
                                            {school?.PERCENTAGE?.toFixed(1)}%
                                        </div>
                                    </div>
                                ))}

                            </LoaderContainer>
                        </div>

                    </div>
                </div>
            </div>
            <div className="py-4 flex justify-end">
                    <div className="flex items-end">
                        <span className="text-white">Powered By </span>
                        <img src={Edvisiondarklogo} height="75px" width="150px" alt="logo" />
                    </div>
                </div>
        </div>
    )
}